<img [src]="_avatarSrc()" alt="avatar" width="104" height="104" (error)="onImageError()" />
